<div
  class="grid-wrapper d-flex flex-column flex-grow-1"
  [class.maximized]="!isMinimized"
>
  <div class="d-flex mb-3 align-items-center">
    <div class="title" *ngIf="title">{{ title }}</div>
    <div class="ms-auto"></div>
    <ng-container *ngFor="let gridAction of gridActions">
      <i
        class="action feather"
        *ngIf="gridAction.icon"
        (click)="gridAction.onAction()"
        [title]="gridAction.title"
        [class]="gridAction.class"
      ></i>
      <button
        class="btn btn-sm btn-outline-primary ms-2 d-flex align-items-center"
        (click)="gridAction.onAction()"
      >
        <i class="feather icon-btn m-0 me-2" [class]="gridAction.class"></i>
        <span>{{ gridAction.description }}</span>
      </button>
    </ng-container>
    <i
      class="action feather icon-download"
      *ngIf="canDownloadExcel"
      (click)="downloadExcel()"
      title="scarica"
    ></i>
    <!-- <i
      *ngIf="isMinimized"
      class="action feather icon-maximize-2"
      (click)="maximize()"
      title="massimizza"
    ></i>

    <i
      *ngIf="!isMinimized"
      class="action feather icon-minimize-2"
      (click)="minimize()"
      title="minimizza"
    ></i> -->
  </div>

  <heitown-data-grid
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [items]="items"
    [canView]="canView"
    [canEdit]="canEdit"
    [canDelete]="canDelete"
    [customActions]="customActions"
    [showDeleteBtn]="$any(showDeleteBtn)"
    (view)="view.emit($event)"
    (edit)="edit.emit($event)"
    (delete)="delete.emit($event)"
  >
  </heitown-data-grid>
  <div class="d-flex align-items-center mt-2" *ngIf="paged && totalRows > 0">
    <div>
      Risultati:
      {{ firstRecord + ' - ' + lastRecord }}
      di {{ totalRows }}
    </div>

    <ngb-pagination
      class="d-flex justify-content-end ms-auto"
      [page]="currentPage"
      (pageChange)="onPageChange($event)"
      [pageSize]="pageSize"
      [maxSize]="5"
      [rotate]="true"
      [boundaryLinks]="false"
      [collectionSize]="totalRows"
      size="sm"
    ></ngb-pagination>
    <!-- <div class="text-right ms-3">
    Page Size:
    <select [formControl]="pageSizeControl">
      <option [ngValue]="10">10</option>
      <option [ngValue]="20">20</option>
      <option [ngValue]="50">50</option>
    </select>
  </div> -->
  </div>
</div>
